export const galapagos = {
  meta: {
    name: 'Galápagos'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgb(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#013857'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #00324f'
    },
    divider: {
      color: '#165173'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#165173',
        color: 'var(--color-white)'
      }
    },

    section: {
      heading: {
        color: {
          _: '#4087ae',
          hover: '#72aed0',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#50c0af'
            }
          },
          color: {
            _: '#4087ae',
            active: 'var(--color-white)'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #165173'
        },
        active: {
          item: {
            color: '#4087ae'
          }
        }
      },
      item: {
        backgroundColor: {
          active: 'rgba(0,0,0,.1)',
          hover: 'rgba(0,0,0,.05)'
        },
        color: {
          _: '#4087ae',
          hover: '#72aed0',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#00324f'
      },
      name: {
        color: 'var(--color-white)'
      },
      company: {
        color: '#36779b'
      },
      trigger: {
        backgroundColor: '#063e5e',
        color: 'var(--color-white)'
      }
    }
  }
};
